import { useMemo } from 'react'
import { lastMonths, parseRange, rangeLabel, rangeToFromTo, seoulToday, type RangeKey } from '@/lib/dates'
import { FilterSelect, useQueryParam } from './FilterBar'
import { Segmented } from './Segmented'

const PRESETS: { value: RangeKey; label: string }[] = [
  { value: 'yesterday', label: '어제' },
  { value: '7d', label: '7일' },
  { value: '30d', label: '30일' },
  { value: '90d', label: '90일' },
]

/** The period of a list page, kept in the address as `?range=` (오늘's tiles
 *  link here with 7d and 30d). Missing or unknown values fall back to
 *  `fallback`. */
export function useRange(fallback: RangeKey = '30d'): { range: RangeKey; setRange: (r: RangeKey) => void; from: string; to: string; label: string } {
  const [raw, set] = useQueryParam('range', fallback)
  const range = parseRange(raw, fallback)
  const { from, to } = useMemo(() => rangeToFromTo(range, seoulToday()), [range])
  return { range, setRange: (r) => set(r), from, to, label: rangeLabel(range) }
}

/** 어제 · 7일 · 30일 · 90일 and a month of the last twelve. A chosen month
 *  turns the segments off; the empty month option goes back to 30일. */
export function RangeFilter({ range, onChange }: { range: RangeKey; onChange: (r: RangeKey) => void }) {
  const month = range.startsWith('month:') ? range : ''
  const months = lastMonths(12)
  return (
    <>
      <Segmented<string>
        label="기간"
        options={PRESETS}
        value={month ? '' : range}
        onChange={(v) => onChange(v as RangeKey)}
      />
      <FilterSelect
        label="월"
        value={month}
        onChange={(v) => onChange(v ? (v as RangeKey) : '30d')}
        options={[{ value: '', label: '월 선택' }, ...months.map((m) => ({ value: `month:${m}`, label: m.replace('-', '. ') }))]}
      />
    </>
  )
}
